<div [ngClass]="theme?.root">
  <div [class.container]="!isChild" [ngClass]="theme?.container">
    @if (accordionTitle) {
      <div class="wysiwyg py-v-spacing sm:p-v-spacing text-center" [innerHTML]="accordionTitle">
      </div>
    }
    <div class="flex flex-col md:flex-row mx-auto" [ngClass]="{'max-w-[890px]': !accordionImageInArray && !showRightContent && !showLeftContent, 'md:gap-6': showLeftContent && !accordionImageInArray}">
      @if (showLeftContent && !accordionImageInArray) {
        <div
          class="accordion-left-content w-full md:w-1/2 pt-12 pb-v-spacing md:px-6">
          <div class="wysiwyg" [innerHTML]="accordionLeftContent"></div>
          @if (!!buttonLabel) {
            <div class="button-section mt-8">
              <vision-button defaultStyle="primary" [data]="buttonData"></vision-button>
            </div>
          }
        </div>
      }
      <div class="flex flex-1" [ngClass]="{'items-start flex-col md:flex-row': accordionImageInArray, 'flex-col md:flex-row md:gap-6': showRightContent && !accordionImageInArray}">
        <div class="accordion w-full {{ accordionPadding }}" [ngClass]="{'lg:w-1/2': accordionImageInArray || showRightContent, 'md:px-6': (showRightContent || showLeftContent) && !accordionImageInArray}">
          @for (accordionItem of data.accordionItems; track accordionItem; let first = $first; let last = $last) {
            <div>
              @if (accordionItem?.accordionSectionTitle[0]?.sectionTitle) {
                <div
                  [innerHTML]="accordionItem.accordionSectionTitle[0].sectionTitle"
                  class="wysiwyg section-title pb-v-spacing sm:p-v-spacing mb-3 md:!pt-12"
                [ngClass]="{'has-side-content': showLeftContent || showRightContent}"></div>
              }
            <div class="accordion-item {{
              accordionType !== ' bg-white' ? 'border-color-ace-gray-400 py-v-spacing mb-5' : 'boxed p-v-spacing !mb-3'
            }}" [class.first-item]="first" [class.last-item]="last" [ngClass]="'accordion-item' + accordionType"
                (keyup.enter)="toggle(accordionItem, itemTitle)" tabindex="0">
                <div class="wrapper">
                  <div class="w-full">
                    <div #itemTitle class="group item-title flex justify-between items-center cursor-pointer"
                      (click)="toggle(accordionItem, itemTitle)">
                      <div class="title w-4/5 wysiwyg headingConfig" [innerHTML]="accordionItem.itemTitle"></div>
                      <div class="icon group-hover:text-ace-blue-500 text-base text-lg mt-1">
                        <div [class.hidden]="accordionItem.showDescription">
                          <span [innerHTML]="openIcon"></span>
                        </div>
                        <div [class.hidden]="!accordionItem.showDescription">
                          <span [innerHtml]="closeIcon"></span>
                        </div>
                      </div>
                    </div>
                    <div class="item-description w-full mt-4 wysiwyg" [class.hidden]="!accordionItem.showDescription"
                    [innerHTML]="accordionItem.itemDescription"></div>
                    <!-- Mobile accordion image -->
                    @if (hasAccordionImage(accordionItem) && accordionItem.showDescription) {
                      <div class="lg:hidden">
                        <img class="pt-v-spacing"
                          [src]="accordionImageURL(accordionItem.accordionImage[0].url)"
                          [alt]="accordionItem.accordionImage[0].altText ? accordionItem.accordionImage[0].altText : ''">
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <!-- Desktop accordion image -->
        @if (accordionImageInArray) {
          <div class="accordion-image hidden lg:block w-1/2 py-v-spacing sm:px-v-spacing">
            @for (accordionItem of data.accordionItems; track accordionItem) {
              <div>
                @if (accordionItem.showDescription && hasAccordionImage(accordionItem)) {
                  <img
                    [src]="accordionImageURL(accordionItem.accordionImage[0].url)"
                    [alt]="accordionItem.accordionImage[0].altText ? accordionItem.accordionImage[0].altText : ''">
                }
              </div>
            }
          </div>
        }
        <!-- Right content column (e.g. Wistia video via Redactor shortcode) -->
        @if (showRightContent && !accordionImageInArray) {
          <div
            class="accordion-right-content order-first md:order-none w-full md:w-1/2 pt-12 md:pb-v-spacing md:px-6">
            <div class="wysiwyg" [innerHTML]="accordionRightContent"></div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
